import React from 'react';
import BillingDetailDTO from 'features/billings/dtos/BillingDetailDTO';
import BillingDetail from './BillingDetail';
import PageCard from 'features/shared/components/card/PageCard';
import BillingDetailHeader from './BillingDetailHeader';

interface Props {
  title: string;
  billingDetails: BillingDetailDTO[];
  periodFrom: Date;
  periodTo: Date;
}

const BillingArea = ({ title, billingDetails, periodFrom, periodTo }: Props) => {
  // sub-renders
  const renderDetails = () => {
    const count = billingDetails.length;

    return billingDetails.map((item, index) =>
      <div className="mb-lg-1" key={index}>
        <BillingDetail 
          billingDetail={item} 
          periodFrom={periodFrom!}
          periodTo={periodTo!}
        />
        {renderDivider(count, index)}
      </div>
    );
  }

  const renderDivider = (count: number, index: number) => {
    if (index < count - 1) {
      return <hr className="d-lg-none"/>;
    }
  }

  // render
  return (
    <PageCard title={title}>
      <BillingDetailHeader />
      {renderDetails()}
    </PageCard>
  )
}

export default BillingArea;
